import { useDispatch, useSelector } from 'react-redux';
import { useUpdateEffect } from '@guryou/hooks';
import { StateStatus } from '../core/StateStatus';
const defaultSelector = () => {
  return {
    status: StateStatus.NOT_INITIALIZED
  };
};
const useEffectOnSuccess = function (stateSelector, effect) {
  let deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => {
    if (Array.isArray(stateSelector)) {
      const values = stateSelector.map(fn => fn(state));
      return values.sort((a, b) => a.version - b.version).pop();
    }
    if (stateSelector) {
      return stateSelector(state);
    }
    return defaultSelector(state);
  });
  useUpdateEffect(() => {
    if (status === StateStatus.LOADED) {
      effect(data, request);
    }
  }, [dispatch, data, status, ...deps]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useEffectOnSuccess;